import { DeleteOutlined, EditOutlined, PlusOutlined } from '@ant-design/icons';
import { App, Button, Empty, Popconfirm, Tag } from 'antd';
import { deleteTemplate } from '../api';
import { GalaTemplate, errorText } from '../contract';
import { fileUrl } from '../lib/file-url';
import styles from '../styles.module.scss';

interface Props {
  eventId: number;
  templates: GalaTemplate[];
  onAdd: () => void;
  onEdit: (template: GalaTemplate) => void;
  onChanged: () => void | Promise<void>;
}

/** Khối "Mẫu vé": thẻ mỗi mẫu (ảnh, tên, nhóm, tag Mặc định) + nút Thêm / Sửa / Xoá. */
const TemplatesSection = ({ eventId, templates, onAdd, onEdit, onChanged }: Props) => {
  const { message } = App.useApp();

  const remove = async (t: GalaTemplate) => {
    try {
      await deleteTemplate(eventId, t.id);
      message.success('Đã xoá mẫu vé.');
      await onChanged();
    } catch (e) {
      message.error(errorText(e, 'Không xoá được mẫu vé (có thể đang có vé dùng mẫu này).'));
    }
  };

  return (
    <section className={styles.card} aria-label="Mẫu vé">
      <div className={styles.toolbar} style={{ marginBottom: 12 }}>
        <h3 className={styles.cardTitle} style={{ margin: 0, flex: 1 }}>
          Mẫu vé
        </h3>
        <Button type="primary" icon={<PlusOutlined />} onClick={onAdd}>
          Thêm mẫu
        </Button>
      </div>
      {templates.length === 0 ? (
        <Empty
          image={Empty.PRESENTED_IMAGE_SIMPLE}
          description="Chưa có mẫu vé. Thêm một mẫu (ảnh nền + chỗ in tên) để vẽ vé cho khách."
        />
      ) : (
        <div className={styles.tplCards}>
          {templates.map((t) => (
            <div key={t.id} className={styles.tplCard}>
              <div className={styles.tplThumb}>
                <img src={fileUrl(t.imageKey)} alt={`Ảnh mẫu ${t.name}`} loading="lazy" />
              </div>
              <div className={styles.tplCardBody}>
                <div className={styles.tplCardName} title={t.name}>
                  {t.name}
                </div>
                <div>
                  {t.isDefault && <Tag color="green">Mặc định</Tag>}
                  {t.guestGroup && <Tag color="blue">Nhóm {t.guestGroup}</Tag>}
                </div>
              </div>
              <div className={styles.tplCardActions}>
                <Button size="small" icon={<EditOutlined />} onClick={() => onEdit(t)}>
                  Sửa
                </Button>
                <Popconfirm
                  title="Xoá mẫu vé này?"
                  description="Chỉ xoá được khi chưa có vé nào dùng mẫu."
                  okText="Xoá"
                  cancelText="Huỷ"
                  okButtonProps={{ danger: true }}
                  onConfirm={() => remove(t)}
                >
                  <Button size="small" danger icon={<DeleteOutlined />} aria-label={`Xoá mẫu ${t.name}`} />
                </Popconfirm>
              </div>
            </div>
          ))}
        </div>
      )}
    </section>
  );
};

export default TemplatesSection;
